<script>
import LogInfoTable from '@/components/Log/LogInfoTable.vue';
import LogGrokTable from '@/components/Log/LogGrokTable.vue';
import LogQueriedTable from '@/components/Log/LogQueriedTable.vue';
import LogAddWidgetTable from '@/components/Log/LogAddWidgetTable.vue';
import LogSavedSearchTable from '@/components/Log/LogSavedSearchTable.vue';
import {
  METRIC_QUERY_TYPE,
  TABLE_QUERY_TYPE,
  VIEW_GROK_TAB_KEY,
  VIEW_SAVED_SEARCHES_TAB_KEY,
} from '@/components/Log/log.constants';
import { mapGetters, mapState } from 'vuex';
import {
  LOG_RESOURCE_GROUP,
  ANALYTICS_RESOURCE_GROUP,
  HOME_RESOURCE_GROUP,
} from '@/router/constant';
import { usePermissions } from '@/hooks/usePermissions';

export default {
  components: {
    LogInfoTable,
    LogQueriedTable,
    LogAddWidgetTable,
    LogGrokTable,
    LogSavedSearchTable,
  },
  computed: {
    ...mapState('logState/logCommonState', [
      'queryEnableSavedSearchType',
      'isADType',
    ]),
    viewGrokTable() {
      return this.currView === VIEW_GROK_TAB_KEY;
    },
    viewSavedSearchTable() {
      return this.currView === VIEW_SAVED_SEARCHES_TAB_KEY;
    },
    displayAddWidget() {
      return (
        this.queryEnableSavedSearchType === METRIC_QUERY_TYPE ||
        this.queryEnableSavedSearchType === TABLE_QUERY_TYPE
      );
    },
    hasWritePermission() {
      const { hasCapabilityWritePermission } = usePermissions();

      return (
        hasCapabilityWritePermission(
          this.isADType ? ANALYTICS_RESOURCE_GROUP : LOG_RESOURCE_GROUP,
        ) && hasCapabilityWritePermission(HOME_RESOURCE_GROUP)
      );
    },
  },
  data() {
    return {
      currView: false,
      viewQueriedTable: false,
    };
  },
  watch: {
    '$route.query.currView': {
      immediate: true,
      handler(newValue) {
        this.currView = newValue;
      },
    },
    '$route.query.queryExec': {
      immediate: true,
      handler(newValue) {
        this.viewQueriedTable = newValue?.length > 0 ? true : false;
      },
    },
  },
};
</script>

<template>
  <div>
    <div v-if="viewQueriedTable" class="log-queried-table-box">
      <LogQueriedTable class="log-query-table" />
      <LogAddWidgetTable
        v-if="displayAddWidget && hasWritePermission"
        class="log-add-widget"
        :queryType="queryEnableSavedSearchType"
      />
    </div>
    <div v-else>
      <LogGrokTable v-if="viewGrokTable" />
      <LogSavedSearchTable v-else-if="viewSavedSearchTable" />
      <LogInfoTable v-else />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.log-queried-table-box {
  display: flex;
}
.log-query-table {
  width: 100%;
}
.log-add-widget {
  width: 25%;
  margin-left: 0.875rem;
}
</style>
